export default "https://assets.egbcdn.net/assets/packs/_/images/logo-egb-n-ccb61269edf922d644b252318f5d682b.svg";